export enum UserRole {
    SUPER_ADMIN = 'super-admin',
    SCHOOL_ADMIN = 'school-admin',
    STUDENT = 'student',
    TEACHER = 'teacher',
}

export type Role = UserRole;

export type User = {
    userId: string,
    role: Role
}

export type AuthContextType = {
    user: User | null,
    isAuthenticated: boolean,
    login: (token: string, userData: User) => void,
    logout: () => Promise<void>,
    isAuthLoading: boolean
}